import React from 'react';
import LazyImage from '../LazyImage/LazyImage';
import './BlogPreview.css';

function BlogPreview() {
  const articles = [
    {
      id: 1,
      title: 'Top 10 Investment Areas in Karachi 2024',
      description: 'Discover the most promising real estate investment opportunities in Pakistan\'s largest city.',
      image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80',
      category: 'Investment',
      date: 'Dec 28, 2024',
      readTime: '5 min read'
    },
    {
      id: 2,
      title: 'Understanding Property Ownership Laws in Pakistan',
      description: 'A comprehensive guide to property ownership, transfer, and legal requirements.',
      image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80',
      category: 'Legal',
      date: 'Dec 25, 2024',
      readTime: '8 min read'
    },
    {
      id: 3,
      title: 'Smart Home Features That Add Value',
      description: 'How modern technology can increase your property\'s market value and appeal.',
      image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80',
      category: 'Technology',
      date: 'Dec 22, 2024',
      readTime: '6 min read'
    }
  ];

  const handleArticleClick = (articleId) => {
    if (window.navigateTo) {
      window.navigateTo('blog-detail');
    } else {
      alert(`Navigating to article ${articleId}`);
    }
  };

  const handleViewAll = () => {
    if (window.navigateTo) {
      window.navigateTo('blogs');
    } else {
      alert('Navigating to all articles');
    }
  };

  return (
    <section className="blog-preview">
      <div className="container">
        <div className="section-header">
          <h2>Latest Insights & Guides</h2>
          <p>Expert advice and market insights to help you make informed decisions</p>
        </div>

        <div className="articles-grid">
          {articles.map(article => (
            <div
              key={article.id}
              className="article-card"
              onClick={() => handleArticleClick(article.id)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && handleArticleClick(article.id)}
              aria-label={`Read article: ${article.title}`}
            >
              <div className="article-image">
                <LazyImage
                  src={article.image}
                  alt={article.title}
                  aspectRatio="16/9"
                />
                <div className="article-category">{article.category}</div>
              </div>
              <div className="article-content">
                <div className="article-meta">
                  <span>{article.date}</span>
                  <span className="separator">•</span>
                  <span>{article.readTime}</span>
                </div>
                <h3>{article.title}</h3>
                <p>{article.description}</p>
                <span className="read-more">Read More →</span>
              </div>
            </div>
          ))}
        </div>

        <div className="view-all-container">
          <button className="btn-view-all" onClick={handleViewAll}>View All Articles</button>
        </div>
      </div>
    </section>
  );
}

export default BlogPreview;
